import { DateSelection } from '@/interfaces/dateselection.interface'
export const dateSelections: DateSelection[] = [
  {
    name: 'now',
    title: { sv: 'Just nu', en: 'Now' },
    range: [['minute', -10], 'now'],
    access: ['FEAT_ANALYSIS-LIVE_READER'],
    icon: { sv: 'Icon-Calendar-Now-SV', en: 'Icon-Calendar-Now-EN' },
    largeIcon: { sv: 'Icon-Calendar-Now-SV-32', en: 'Icon-Calendar-Now-EN-32' }
  },
  {
    name: 'last24h',
    title: { sv: 'Senaste 24 timmarna', en: 'Last 24 hours' },
    range: ['now', ['hour', -24]],
    access: ['FEAT_ANALYSIS-LIVE_READER'],
    icon: { sv: 'Icon-Calendar-24', en: 'Icon-Calendar-24' },
    largeIcon: { sv: 'Icon-Calendar-24-32', en: 'Icon-Calendar-24-32' }
  },
  {
    name: 'yesterday',
    title: { sv: 'Igår', en: 'Yesterday' },
    range: [
      ['day', -1],
      ['day', 'minute', -1]
    ],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Calendar-Yesterday', en: 'Icon-Calendar-Yesterday' },
    largeIcon: { sv: 'Icon-Calendar-Yesterday-32', en: 'Icon-Calendar-Yesterday-32' }
  },
  {
    name: 'last7d',
    title: { sv: 'Senaste 7 dagarna', en: 'Last 7 days' },
    range: ['now', ['day', -7]],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Last-7-Days_x24', en: 'Icon-Last-7-Days_x24' },
    largeIcon: { sv: 'Icon-Last-7-Days_x32', en: 'Icon-Last-7-Days_x32' }
  },
  {
    name: 'last30d',
    title: { sv: 'Senaste 30 dagarna', en: 'Last 30 days' },
    range: ['now', ['day', -30]],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Last-30-Days_x24', en: 'Icon-Last-30-Days_x24' },
    largeIcon: { sv: 'Icon-Last-30-Days_x32', en: 'Icon-Last-30-Days_x32' }
  },
  {
    name: 'lastquarter',
    title: { sv: 'Förra kvartalet', en: 'Last quarter' },
    range: [
      ['quarter', -1],
      ['quarter', 'minute', -1]
    ],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Q1_x24', en: 'Icon-Q1_x24' },
    largeIcon: { sv: 'Icon-Q1_x32', en: 'Icon-Q1_x32' }
  },
  {
    name: 'last12m',
    title: { sv: 'Senaste 12 månaderna', en: 'Last 12 months' },
    range: ['now', ['month', -12]],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Last-12-Months_x24', en: 'Icon-Last-12-Months_x24' },
    largeIcon: { sv: 'Icon-Last-12-Months_x32', en: 'Icon-Last-12-Months_x32' }
  },
  {
    name: 'currentyear',
    title: { sv: 'Innevarande år', en: 'Current year' },
    range: ['year', 'now'],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Current-Year_x24', en: 'Icon-Current-Year_x24' },
    largeIcon: { sv: 'Icon-Current-Year_x32', en: 'Icon-Current-Year_x32' }
  },
  {
    name: 'lastyear',
    title: { sv: 'Föregående år', en: 'Previous year' },
    range: [
      ['year', -1],
      ['year', 'minute', -1]
    ],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Calendar-Year-SV', en: 'Icon-Calendar-Year-EN' },
    largeIcon: { sv: 'Icon-Calendar-Year-SV-32', en: 'Icon-Calendar-Year-EN-32' }
  },
  {
    name: 'last5years',
    title: { sv: 'Senaste 5 åren', en: 'Last 5 years' },
    range: ['now', ['year', -5]],
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Calendar-Year-SV', en: 'Icon-Calendar-Year-EN' },
    largeIcon: { sv: 'Icon-Calendar-Year-SV-32', en: 'Icon-Calendar-Year-EN-32' }
  },
  {
    name: 'custom',
    title: { sv: 'Utökade tidsinställningar', en: 'Extended time settings' },
    access: ['FEAT_ANALYSIS-HISTORICAL_READER'],
    icon: { sv: 'Icon-Clock-Medium', en: 'Icon-Clock-Medium' }
  }
]
